import { Box, styled } from '@mui/material';

import { BANKS_LOGOS, BANK_REFIN_LOGOS } from './logos.tsx';
import PartnerBankImage from './PartnerBankImage/index.ts';

const LogosContainer = styled('div')({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  flexWrap: 'wrap',
});

interface PartnerBanksProps {
  variant?: 'unicolored' | 'multicolored';
  data?: { name: string; linkEnabled: boolean }[];
  isRefin?: boolean;
}

const PartnerBanks = ({ variant = 'unicolored', isRefin = false }: PartnerBanksProps) => {
  const logos = isRefin ? [...BANK_REFIN_LOGOS] : [...BANKS_LOGOS];

  return (
    <>
      <Box sx={{ display: { xs: 'block', md: 'none' } }}>
        <LogosContainer>
          {logos.map((item) => (
            <PartnerBankImage {...{ item, variant }} key={item.key} />
          ))}
        </LogosContainer>
      </Box>

      <Box sx={{ display: { xs: 'none', md: 'block' } }}>
        {[logos.slice(0, 4), logos.slice(4, 9), logos.slice(9, 14), logos.slice(14, 19)].map(
          (section, index) => (
            <LogosContainer key={index}>
              {section.map((item) => (
                <PartnerBankImage
                  {...{ item, variant }}
                  key={item.key}
                  // isLink={
                  //   data?.find(({ name }) => name === item.key)?.linkEnabled
                  // }
                />
              ))}
            </LogosContainer>
          ),
        )}
      </Box>
    </>
  );
};

export default PartnerBanks;
